import React from 'react';
import { Users } from 'lucide-react';

interface TableViewProps {}

const TableView: React.FC<TableViewProps> = () => {
  return (
    <div className="p-3 sm:p-6 max-w-7xl mx-auto animate-page-enter">
      {/* Header */}
      <div className="mb-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Table View</h1>
            <p className="text-gray-600 dark:text-gray-400 mt-1">
              Table management functionality has been removed
            </p>
          </div>
        </div>
      </div>

      {/* Empty State */}
      <div className="text-center py-12">
        <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center">
          <Users className="w-8 h-8 text-gray-400" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">Table View Disabled</h3>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          Table view functionality has been removed from this application.
        </p>
        <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/30 rounded-lg max-w-md mx-auto">
          <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-2">Note:</h4>
          <p className="text-xs text-blue-800 dark:text-blue-200">
            You can still add tables in the Features page and select tables when creating orders.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TableView; 